import React from 'react'
import cx from 'classnames'
import StoryOverlaySectionItem from './storyOverlaySectionItem'
import Image from '../contentParticles/image'
import { Citations } from '../citations'

class StoryOverlaySection extends React.Component {
  renderStoryOverlaySectionItems() {
    const { content, theme, cardNodes, sectionIndex } = this.props

    return content.items.map((item, index) => (
      <StoryOverlaySectionItem
        content={item}
        theme={theme}
        key={`story-overlay-section-item-${sectionIndex}${index}`}
        ref={(card) => {
          cardNodes.set(`${sectionIndex}-${index}`, card)
        }}
      />
    ))
  }

  render() {
    const { content, theme } = this.props

    return (
      <div>
        {content.images && (
          <div>
            <Image images={content.images} />
            <p
              dangerouslySetInnerHTML={{ __html: content.images.caption }}
              className="text-granite-gray mt-10 mb-20"
            />
          </div>
        )}
        {!content.hideTitle && (
          <div
            className={cx('pb-10 border-b-4 pt-30', {
              'flex flex-wrap': content.sdg,
            })}
          >
            <h3
              className={cx(
                `${theme.textColor} text-18 xl:text-24 ${theme.borderColor}`,
                {
                  ' md:mr-auto md:self-end': content.sdg,
                }
              )}
              dangerouslySetInnerHTML={{ __html: content.sectionTitle }}
            />
            {content.sdg &&
              content.sdg.map((icon, index) => {
                return (
                  <div
                    key={index}
                    className={cx({
                      'ml-10': index === 0 && content.sdg.length === 1,
                      'mr-10': index === 0 && content.sdg.length > 1,
                    })}
                  >
                    <a className="block" href="/appendix#un">
                      <Image key={index} images={icon} sdg />
                    </a>
                  </div>
                )
              })}
          </div>
        )}

        {content.image && (
          <div className="pt-30">
            <Image images={content.image} />
          </div>
        )}

        {content.description && (
          <p className="text-16 mb-55">{content.description}</p>
        )}


        {this.renderStoryOverlaySectionItems()}

        <Citations className="mb-10" citations={content.citations} />
      </div>
    )
  }
}

export default StoryOverlaySection
